import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { patchApiData } from "../helpers/AxiosInstance";

interface IUsePatchHook {
  queryKey: string[];
  navigateURL?: string;
}

const usePatchHook = (props: IUsePatchHook) => {
  const { queryKey, navigateURL } = props;
  const queryClient: any = useQueryClient();
  const navigate = useNavigate();

  const {
    isPending: isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  } = useMutation({
    mutationFn: patchApiData,
    onSuccess: (data) => {
      if (data.status === 200 || data.status === 201) {
        toast.success("Updated successfully");
        if (navigateURL) {
          navigate(navigateURL);
        }
      } else {
        toast.error(data?.data?.message ?? "Somethings went wrongs");
      }
    },
    onError: (error) => {
      toast.error("Somethings went wrongs");
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey ?? null);
    },
  });
  return {
    isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  };
};

export default usePatchHook;
